import { Turbo } from "@hotwired/turbo-rails";
import { runComponentPackages, runControllerPackage } from "@lib/packageRunner";
import { application } from "@controllers/application";

import MarqueeCarouselController from "@controllers/preline/carousel/marquee-carousel";
import ReviewsIoWidgetController from "@controllers/preline/reviews_io_widget/reviews_io_widget";

application.register("marquee-carousel", MarqueeCarouselController);
application.register("reviews-io-widget", ReviewsIoWidgetController);

Turbo.session.drive = false;
document.addEventListener("DOMContentLoaded", async () => {
  runControllerPackage();
  runComponentPackages();
});
